import Vue from 'vue'
import router from './router'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import * as Helpers from "./helpers"
import store from './store/index'
import 'typeface-roboto/index.css'
import fullscreen from 'vue-fullscreen'
import Vuelidate from 'vuelidate'
import VueMask from 'v-mask'

Vue.use(fullscreen)
Vue.use(Vuelidate)
Vue.use(VueMask)


Vue.config.productionTip = false;

Vue.prototype.Helpers = Helpers;

new Vue({
    router,
    vuetify,
    store,
    render: h => h(App)
}).$mount('#app')
